// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3BxXp","author":"Table_author__Uzsyk","authorImage":"Table_authorImage__3pfO9","unreadRow":"Table_unreadRow__2SrB4"};